import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WhatsappBlockService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI8 + "/api";

  blockNumber(contact: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/block`, contact);
  }


  UnblockNumber(contact: any): Observable<Object> {
    return this.http.request('DELETE', `${this.url}/unblock`, {
      body: contact,
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  getUnblockList(): Observable<Object> {
    return this.http.get(`${this.url}/blockList`);
  }

    deleteByContactWaId(contactWaId: any): Observable<Object> {
        return this.http.delete(`${this.url}/whatsapp/deletechat/${contactWaId}`);
    }

}
